const bespokeServerAppMockups2Html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Bespoke Server App — Style Explorations II</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Inter:wght@400;500;600;700;800;900&family=DM+Sans:wght@400;500;600;700;800&display=swap');

*{margin:0;padding:0;box-sizing:border-box}

body{
  background:#111;
  color:#fff;
  font-family:system-ui,-apple-system,sans-serif;
  padding:40px 20px;
}

h1{text-align:center;font-size:28px;font-weight:700;margin-bottom:8px;letter-spacing:-0.5px}
.subtitle{text-align:center;font-size:14px;color:#888;margin-bottom:40px}

.grid-wrapper{
  display:grid;
  grid-template-columns:80px repeat(3,375px);
  grid-template-rows:40px repeat(3,812px);
  gap:24px;
  justify-content:center;
  align-items:start;
}

.col-header{text-align:center;font-size:16px;font-weight:700;letter-spacing:1px;text-transform:uppercase;display:flex;align-items:end;justify-content:center;padding-bottom:8px}
.col-header.duolingo{color:#58CC02}
.col-header.spotify{color:#1DB954}
.col-header.cashapp{color:#00D632}

.row-label{writing-mode:vertical-lr;transform:rotate(180deg);font-size:13px;font-weight:600;letter-spacing:2px;text-transform:uppercase;color:#666;display:flex;align-items:center;justify-content:center}

.phone{width:375px;height:812px;border-radius:40px;overflow:hidden;box-shadow:0 8px 40px rgba(0,0,0,0.5),0 0 0 3px #333;position:relative}

.corner{grid-column:1;grid-row:1}

.footer{text-align:center;font-size:12px;color:#555;margin-top:40px;padding-bottom:40px}

/* ========== DUOLINGO STYLE ========== */
.duo-screen{
  font-family:'Nunito',system-ui,sans-serif;
  background:#fff;
  color:#3C3C3C;
  height:100%;
  display:flex;
  flex-direction:column;
}
.duo-screen .status-bar{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#AFAFAF;font-weight:700}
.duo-screen .nav-bottom{display:flex;justify-content:space-around;padding:10px 0 28px;border-top:2px solid #E5E5E5;margin-top:auto;background:#fff}
.duo-screen .nav-bottom span{font-size:10px;color:#AFAFAF;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;font-weight:800}
.duo-screen .nav-bottom span.active{color:#58CC02}

.duo-top-bar{display:flex;align-items:center;gap:12px;padding:8px 20px 12px}
.duo-streak{display:flex;align-items:center;gap:4px;font-size:13px;font-weight:800;color:#FF9600}
.duo-xp{display:flex;align-items:center;gap:4px;font-size:13px;font-weight:800;color:#58CC02;margin-left:auto}
.duo-hearts{display:flex;align-items:center;gap:4px;font-size:13px;font-weight:800;color:#FF4B4B}

/* Duo Recap */
.duo-recap-hero{background:#58CC02;margin:0 16px;border-radius:20px;padding:28px 24px;text-align:center;color:#fff;position:relative;overflow:hidden}
.duo-recap-hero::after{content:'';position:absolute;top:-20px;right:-20px;width:100px;height:100px;background:rgba(255,255,255,0.1);border-radius:50%}
.duo-recap-hero .mascot{font-size:56px;display:block;margin-bottom:8px}
.duo-recap-hero h2{font-size:24px;font-weight:900}
.duo-recap-hero .sub{font-size:14px;font-weight:600;opacity:0.85;margin-top:4px}

.duo-xp-bar{margin:20px 20px 0}
.duo-xp-bar .label{display:flex;justify-content:space-between;font-size:12px;font-weight:800;color:#AFAFAF;margin-bottom:6px}
.duo-xp-bar .bar{height:14px;background:#E5E5E5;border-radius:7px;overflow:hidden}
.duo-xp-bar .bar .fill{height:100%;background:linear-gradient(90deg,#58CC02,#89E219);border-radius:7px}

.duo-stat-pills{display:flex;gap:8px;padding:16px 20px;flex-wrap:wrap}
.duo-pill{flex:1;min-width:0;background:#F7F7F7;border:2px solid #E5E5E5;border-radius:16px;padding:14px 12px;text-align:center}
.duo-pill .icon{font-size:24px;display:block;margin-bottom:4px}
.duo-pill .val{font-size:20px;font-weight:900;color:#3C3C3C}
.duo-pill .label{font-size:10px;font-weight:700;color:#AFAFAF;margin-top:2px}

.duo-lesson-card{margin:8px 20px;background:#FFF7E1;border:2px solid #FFD900;border-radius:16px;padding:16px;display:flex;align-items:center;gap:12px}
.duo-lesson-card .icon{font-size:32px}
.duo-lesson-card .text{flex:1}
.duo-lesson-card .text .title{font-size:14px;font-weight:800;color:#3C3C3C}
.duo-lesson-card .text .sub{font-size:11px;font-weight:600;color:#AFAFAF;margin-top:2px}
.duo-lesson-card .arrow{font-size:18px;color:#FFD900;font-weight:900}

/* Duo Skills */
.duo-section-title{padding:16px 24px 8px;font-size:18px;font-weight:900;color:#3C3C3C}

.duo-skill-tree{display:flex;flex-direction:column;align-items:center;gap:16px;padding:16px 0}
.duo-skill-node{width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:32px;position:relative}
.duo-skill-node.complete{background:#58CC02;box-shadow:0 4px 0 #46A302}
.duo-skill-node.current{background:#FFD900;box-shadow:0 4px 0 #E5C300;animation:duo-pulse 2s infinite}
.duo-skill-node.locked{background:#E5E5E5;box-shadow:0 4px 0 #CCCCCC}
@keyframes duo-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}
.duo-skill-label{font-size:11px;font-weight:800;color:#AFAFAF;margin-top:4px;text-align:center}
.duo-skill-connector{width:3px;height:20px;background:#E5E5E5;border-radius:2px}
.duo-skill-connector.done{background:#58CC02}

.duo-skill-row{display:flex;flex-direction:column;align-items:center}

.duo-progress-card{margin:12px 20px;padding:16px;background:#F7F7F7;border-radius:16px;border:2px solid #E5E5E5}
.duo-progress-card .header{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}
.duo-progress-card .header .title{font-size:14px;font-weight:800}
.duo-progress-card .header .badge{padding:4px 10px;background:#58CC02;color:#fff;border-radius:10px;font-size:11px;font-weight:800}
.duo-progress-card .bar{height:10px;background:#E5E5E5;border-radius:5px;overflow:hidden;margin-top:8px}
.duo-progress-card .bar .fill{height:100%;border-radius:5px}

/* Duo Achievements */
.duo-trophy-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;padding:12px 20px}
.duo-trophy{background:#F7F7F7;border:2px solid #E5E5E5;border-radius:20px;padding:16px 8px;text-align:center}
.duo-trophy.earned{border-color:#FFD900;background:#FFFDF0}
.duo-trophy .icon{font-size:36px;display:block;margin-bottom:6px}
.duo-trophy .name{font-size:10px;font-weight:800;color:#3C3C3C}
.duo-trophy .sub{font-size:9px;font-weight:600;color:#AFAFAF;margin-top:2px}
.duo-trophy.locked .icon{opacity:0.3}
.duo-trophy.locked .name{color:#AFAFAF}

.duo-chest{margin:12px 20px;background:linear-gradient(135deg,#58CC02,#89E219);border-radius:20px;padding:20px;display:flex;align-items:center;gap:16px;color:#fff}
.duo-chest .icon{font-size:44px}
.duo-chest .text .title{font-size:16px;font-weight:900}
.duo-chest .text .sub{font-size:12px;font-weight:600;opacity:0.85;margin-top:4px}

/* ========== SPOTIFY STYLE ========== */
.spot-screen{
  font-family:'DM Sans',system-ui,sans-serif;
  background:#121212;
  color:#fff;
  height:100%;
  display:flex;
  flex-direction:column;
}
.spot-screen .status-bar{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#666;font-weight:500}
.spot-screen .nav-bottom{display:flex;justify-content:space-around;padding:12px 0 28px;border-top:1px solid #282828;margin-top:auto;background:#121212}
.spot-screen .nav-bottom span{font-size:10px;color:#666;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;font-weight:600}
.spot-screen .nav-bottom span.active{color:#1DB954}

/* Spot Recap */
.spot-hero{margin:8px 16px;border-radius:16px;padding:32px 24px;position:relative;overflow:hidden;min-height:220px;display:flex;flex-direction:column;justify-content:flex-end}
.spot-hero.recap{background:linear-gradient(135deg,#1DB954 0%,#1a6834 40%,#191414 100%)}
.spot-hero .tag{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:2px;color:rgba(255,255,255,0.6);margin-bottom:8px}
.spot-hero h2{font-size:28px;font-weight:800;line-height:1.15;margin-bottom:4px}
.spot-hero .sub{font-size:13px;color:rgba(255,255,255,0.7);font-weight:500}

.spot-stat-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;padding:16px 16px 8px}
.spot-stat-card{background:#1E1E1E;border-radius:12px;padding:16px;position:relative;overflow:hidden}
.spot-stat-card::after{content:'';position:absolute;top:-30px;right:-30px;width:80px;height:80px;border-radius:50%;opacity:0.08}
.spot-stat-card.green::after{background:#1DB954}
.spot-stat-card.purple::after{background:#8B5CF6}
.spot-stat-card.orange::after{background:#F59E0B}
.spot-stat-card.pink::after{background:#EC4899}
.spot-stat-card .val{font-size:28px;font-weight:800}
.spot-stat-card .label{font-size:11px;color:#999;font-weight:500;margin-top:4px}

.spot-highlight{margin:8px 16px;background:#1E1E1E;border-radius:12px;padding:16px;display:flex;align-items:center;gap:14px}
.spot-highlight .icon{width:48px;height:48px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:24px}
.spot-highlight .icon.green{background:rgba(29,185,84,0.15)}
.spot-highlight .text .title{font-size:14px;font-weight:700}
.spot-highlight .text .sub{font-size:11px;color:#999;margin-top:2px}

.spot-play-bar{margin:8px 16px;background:#1E1E1E;border-radius:12px;padding:14px 16px;display:flex;align-items:center;gap:12px}
.spot-play-bar .dot{width:10px;height:10px;border-radius:50%;background:#1DB954}
.spot-play-bar .text{flex:1;font-size:12px;color:#999}
.spot-play-bar .text strong{color:#fff}

/* Spot Skills */
.spot-section-head{padding:16px 20px 8px;display:flex;justify-content:space-between;align-items:center}
.spot-section-head h3{font-size:18px;font-weight:800}
.spot-section-head .see-all{font-size:12px;color:#999;font-weight:600}

.spot-skill-cards{display:flex;gap:12px;padding:0 16px;overflow-x:auto}
.spot-skill-card{min-width:140px;border-radius:12px;padding:20px 16px;text-align:center;flex-shrink:0}
.spot-skill-card.s1{background:linear-gradient(180deg,#1DB954 0%,#0D4D25 100%)}
.spot-skill-card.s2{background:linear-gradient(180deg,#8B5CF6 0%,#3B1D8E 100%)}
.spot-skill-card.s3{background:linear-gradient(180deg,#F59E0B 0%,#7C4F06 100%)}
.spot-skill-card .emoji{font-size:32px;display:block;margin-bottom:8px}
.spot-skill-card .name{font-size:13px;font-weight:700}
.spot-skill-card .level{font-size:10px;color:rgba(255,255,255,0.6);font-weight:600;margin-top:4px}

.spot-mix-card{margin:8px 16px;background:linear-gradient(135deg,#1E1E1E 0%,#2a1e3e 100%);border-radius:12px;padding:16px;display:flex;align-items:center;gap:14px}
.spot-mix-card .cover{width:56px;height:56px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:28px;background:linear-gradient(135deg,#8B5CF6,#EC4899)}
.spot-mix-card .info .title{font-size:14px;font-weight:700}
.spot-mix-card .info .sub{font-size:11px;color:#999;margin-top:2px}
.spot-mix-card .info .tags{display:flex;gap:6px;margin-top:8px}
.spot-mix-card .info .tag-pill{padding:3px 10px;background:rgba(255,255,255,0.08);border-radius:50px;font-size:10px;color:#ccc;font-weight:500}

.spot-progress-row{padding:0 16px;margin-top:8px}
.spot-progress-item{display:flex;align-items:center;gap:12px;padding:14px 0;border-bottom:1px solid #1E1E1E}
.spot-progress-item .rank-dot{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:800}
.spot-progress-item .rank-dot.top{background:#1DB954;color:#000}
.spot-progress-item .rank-dot.mid{background:#282828;color:#999}
.spot-progress-item .info{flex:1}
.spot-progress-item .info .name{font-size:13px;font-weight:700}
.spot-progress-item .info .sub{font-size:11px;color:#666}
.spot-progress-item .bar-wrap{width:80px}
.spot-progress-item .bar{height:4px;background:#282828;border-radius:2px;overflow:hidden}
.spot-progress-item .bar .fill{height:100%;border-radius:2px}

/* Spot Achievements */
.spot-wrapped-card{margin:8px 16px;border-radius:16px;padding:32px 24px;text-align:center;position:relative;overflow:hidden}
.spot-wrapped-card.green{background:linear-gradient(135deg,#1DB954,#169c46,#0D7A32)}
.spot-wrapped-card.purple{background:linear-gradient(135deg,#8B5CF6,#6D28D9,#4C1D95)}
.spot-wrapped-card .big-num{font-size:64px;font-weight:900;line-height:1}
.spot-wrapped-card .label{font-size:14px;font-weight:600;opacity:0.8;margin-top:8px}
.spot-wrapped-card .sub{font-size:12px;opacity:0.5;margin-top:4px}

.spot-badge-row{display:flex;gap:12px;padding:12px 16px;overflow-x:auto}
.spot-badge{min-width:100px;background:#1E1E1E;border-radius:12px;padding:16px 12px;text-align:center;flex-shrink:0}
.spot-badge.earned{border:1px solid rgba(29,185,84,0.3)}
.spot-badge.locked{opacity:0.4}
.spot-badge .icon{font-size:28px;display:block;margin-bottom:6px}
.spot-badge .name{font-size:10px;font-weight:700;color:#ccc}

/* ========== CASH APP STYLE ========== */
.cash-screen{
  font-family:'Inter',system-ui,sans-serif;
  background:#000;
  color:#fff;
  height:100%;
  display:flex;
  flex-direction:column;
}
.cash-screen .status-bar{display:flex;justify-content:space-between;padding:14px 24px 8px;font-size:12px;color:#444;font-weight:600}
.cash-screen .nav-bottom{display:flex;justify-content:space-around;padding:12px 0 28px;border-top:1px solid #1a1a1a;margin-top:auto;background:#000}
.cash-screen .nav-bottom span{font-size:10px;color:#444;text-align:center;display:flex;flex-direction:column;align-items:center;gap:4px;font-weight:600}
.cash-screen .nav-bottom span.active{color:#00D632}

/* Cash Recap */
.cash-hero-amount{text-align:center;padding:40px 24px 20px}
.cash-hero-amount .label{font-size:13px;font-weight:500;color:#666;text-transform:uppercase;letter-spacing:2px;margin-bottom:12px}
.cash-hero-amount .amount{font-size:72px;font-weight:900;letter-spacing:-3px;line-height:1}
.cash-hero-amount .amount .dollar{color:#00D632}
.cash-hero-amount .sub{font-size:14px;color:#666;margin-top:8px;font-weight:500}

.cash-divider{height:1px;background:#1a1a1a;margin:0 24px}

.cash-breakdown{padding:20px 24px}
.cash-breakdown-title{font-size:11px;font-weight:700;color:#444;text-transform:uppercase;letter-spacing:2px;margin-bottom:16px}
.cash-line{display:flex;justify-content:space-between;align-items:center;padding:12px 0;border-bottom:1px solid #111}
.cash-line .left{display:flex;align-items:center;gap:12px}
.cash-line .dot{width:8px;height:8px;border-radius:50%}
.cash-line .name{font-size:14px;font-weight:600}
.cash-line .right{font-size:16px;font-weight:800}
.cash-line .right.green{color:#00D632}

.cash-insight{margin:12px 24px;padding:16px;background:#0D1F12;border:1px solid #1a3320;border-radius:12px;display:flex;align-items:center;gap:12px}
.cash-insight .icon{font-size:20px}
.cash-insight .text{font-size:13px;font-weight:500;color:#6FCF87;flex:1}

/* Cash Skills */
.cash-metric-header{padding:20px 24px 16px;text-align:center}
.cash-metric-header h2{font-size:14px;font-weight:700;color:#444;text-transform:uppercase;letter-spacing:2px}

.cash-big-metric{text-align:center;padding:20px}
.cash-big-metric .number{font-size:80px;font-weight:900;letter-spacing:-4px;line-height:1}
.cash-big-metric .unit{font-size:18px;font-weight:700;color:#666;margin-top:4px}
.cash-big-metric .change{display:inline-flex;align-items:center;gap:4px;padding:6px 14px;border-radius:50px;font-size:13px;font-weight:700;margin-top:12px}
.cash-big-metric .change.up{background:#0D1F12;color:#00D632}

.cash-sparkline{padding:0 24px;margin:8px 0}
.cash-sparkline .row{display:flex;align-items:flex-end;gap:4px;height:60px}
.cash-sparkline .bar{flex:1;background:#1a1a1a;border-radius:3px 3px 0 0;min-height:4px}
.cash-sparkline .bar.active{background:#00D632}
.cash-sparkline .bar.current{background:#00D632;box-shadow:0 0 8px rgba(0,214,50,0.3)}
.cash-sparkline .labels{display:flex;justify-content:space-between;padding-top:6px}
.cash-sparkline .labels span{font-size:9px;color:#444;font-weight:600}

.cash-skill-list{padding:16px 24px}
.cash-skill-item{display:flex;align-items:center;gap:14px;padding:14px 0;border-bottom:1px solid #111}
.cash-skill-item .indicator{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:900}
.cash-skill-item .indicator.green{background:#0D1F12;color:#00D632;border:1px solid #1a3320}
.cash-skill-item .indicator.yellow{background:#1F1A0D;color:#F59E0B;border:1px solid #33280D}
.cash-skill-item .indicator.gray{background:#111;color:#444;border:1px solid #222}
.cash-skill-item .info{flex:1}
.cash-skill-item .info .name{font-size:14px;font-weight:700}
.cash-skill-item .info .sub{font-size:11px;color:#444;font-weight:500;margin-top:2px}
.cash-skill-item .score{font-size:18px;font-weight:900}
.cash-skill-item .score.green{color:#00D632}
.cash-skill-item .score.yellow{color:#F59E0B}
.cash-skill-item .score.gray{color:#444}

/* Cash Achievements */
.cash-total-header{text-align:center;padding:32px 24px 24px}
.cash-total-header .label{font-size:11px;font-weight:700;color:#444;text-transform:uppercase;letter-spacing:2px;margin-bottom:8px}
.cash-total-header .amount{font-size:48px;font-weight:900;letter-spacing:-2px}
.cash-total-header .amount .green{color:#00D632}
.cash-total-header .sub{font-size:13px;color:#444;margin-top:4px;font-weight:500}

.cash-achievement-list{padding:0 24px}
.cash-achievement{display:flex;align-items:center;gap:14px;padding:16px 0;border-bottom:1px solid #111}
.cash-achievement .badge-icon{width:48px;height:48px;border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:24px}
.cash-achievement .badge-icon.earned{background:#0D1F12;border:1px solid #1a3320}
.cash-achievement .badge-icon.locked{background:#111;border:1px solid #1a1a1a;opacity:0.4}
.cash-achievement .info{flex:1}
.cash-achievement .info .name{font-size:14px;font-weight:700}
.cash-achievement .info .sub{font-size:11px;color:#444;margin-top:2px}
.cash-achievement .check{font-size:16px;color:#00D632}
.cash-achievement .locked-text{font-size:11px;color:#333;font-weight:600}

.cash-cta{margin:16px 24px;padding:16px;background:#00D632;border-radius:12px;text-align:center}
.cash-cta .text{font-size:15px;font-weight:800;color:#000}
.cash-cta .sub{font-size:11px;color:rgba(0,0,0,0.5);margin-top:4px;font-weight:600}

</style>
</head>
<body>

<h1>Bespoke Server App — Style Explorations II</h1>
<p class="subtitle">The Grove, San Francisco — Post-shift recap: Friday dinner, 5pm–10pm</p>

<div class="grid-wrapper">
  <div class="corner"></div>

  <div class="col-header duolingo">Duolingo</div>
  <div class="col-header spotify">Spotify</div>
  <div class="col-header cashapp">Cash App</div>

  <!-- ===== ROW 1: SHIFT RECAP ===== -->
  <div class="row-label">Shift Recap</div>

  <!-- DUOLINGO RECAP -->
  <div class="phone">
    <div class="duo-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="duo-top-bar">
        <div class="duo-streak">🔥 4</div>
        <div class="duo-xp">⚡ 340 XP</div>
        <div class="duo-hearts">❤️ 5</div>
      </div>
      <div class="duo-recap-hero">
        <span class="mascot">🦉</span>
        <h2>Amazing shift!</h2>
        <div class="sub">You earned 340 XP tonight</div>
      </div>
      <div class="duo-xp-bar">
        <div class="label"><span>Level 7</span><span>340 / 500 XP</span></div>
        <div class="bar"><div class="fill" style="width:68%"></div></div>
      </div>
      <div class="duo-stat-pills">
        <div class="duo-pill"><span class="icon">🍽️</span><div class="val">8</div><div class="label">Tables</div></div>
        <div class="duo-pill"><span class="icon">💰</span><div class="val">$47</div><div class="label">Tip Boost</div></div>
        <div class="duo-pill"><span class="icon">⬆️</span><div class="val">3</div><div class="label">Upsells</div></div>
      </div>
      <div class="duo-lesson-card">
        <div class="icon">🏆</div>
        <div class="text">
          <div class="title">Friday MVP unlocked!</div>
          <div class="sub">Top performer on tonight's shift</div>
        </div>
        <div class="arrow">›</div>
      </div>
      <div class="duo-lesson-card" style="border-color:#58CC02;background:#F0FFF0">
        <div class="icon">📈</div>
        <div class="text">
          <div class="title">New personal best!</div>
          <div class="sub">94% greeting score — beat your old record</div>
        </div>
        <div class="arrow" style="color:#58CC02">›</div>
      </div>
      <div class="nav-bottom">
        <span class="active">◉ Today</span>
        <span>◎ Skills</span>
        <span>◎ Badges</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- SPOTIFY RECAP -->
  <div class="phone">
    <div class="spot-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="spot-hero recap">
        <div class="tag">Your Shift Recap</div>
        <h2>Friday Dinner<br>Wrapped</h2>
        <div class="sub">5pm – 10pm · The Grove SF</div>
      </div>
      <div class="spot-stat-grid">
        <div class="spot-stat-card green"><div class="val" style="color:#1DB954">$47</div><div class="label">Tip Boost</div></div>
        <div class="spot-stat-card purple"><div class="val" style="color:#8B5CF6">8</div><div class="label">Tables Served</div></div>
        <div class="spot-stat-card orange"><div class="val" style="color:#F59E0B">94%</div><div class="label">Greeting Score</div></div>
        <div class="spot-stat-card pink"><div class="val" style="color:#EC4899">3</div><div class="label">Upsells Landed</div></div>
      </div>
      <div class="spot-highlight">
        <div class="icon green">🎯</div>
        <div class="text">
          <div class="title">Best moment: Table 12 double upsell</div>
          <div class="sub">Wine upgrade + dessert in one interaction — rare combo</div>
        </div>
      </div>
      <div class="spot-play-bar">
        <div class="dot"></div>
        <div class="text">Your shift had <strong>more upsells than 82% of servers</strong> this week</div>
      </div>
      <div class="nav-bottom">
        <span class="active">◉ Recap</span>
        <span>◎ Grow</span>
        <span>◎ Awards</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- CASH APP RECAP -->
  <div class="phone">
    <div class="cash-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="cash-hero-amount">
        <div class="label">Tonight's Tip Boost</div>
        <div class="amount"><span class="dollar">$</span>47</div>
        <div class="sub">Friday Dinner · 5pm – 10pm</div>
      </div>
      <div class="cash-divider"></div>
      <div class="cash-breakdown">
        <div class="cash-breakdown-title">Breakdown</div>
        <div class="cash-line">
          <div class="left"><div class="dot" style="background:#00D632"></div><div class="name">Dessert upsells (2)</div></div>
          <div class="right green">+$22.40</div>
        </div>
        <div class="cash-line">
          <div class="left"><div class="dot" style="background:#6FCF87"></div><div class="name">Wine upgrade (1)</div></div>
          <div class="right green">+$16.80</div>
        </div>
        <div class="cash-line">
          <div class="left"><div class="dot" style="background:#3a7d4a"></div><div class="name">Greeting bonus</div></div>
          <div class="right green">+$7.80</div>
        </div>
      </div>
      <div class="cash-insight">
        <div class="icon">📈</div>
        <div class="text">You earned 31% more than your Friday average. Your greeting score hit a personal best.</div>
      </div>
      <div class="cash-insight" style="border-color:#33280D;background:#1F1A0D">
        <div class="icon">💡</div>
        <div class="text" style="color:#F5C842">Tip: Tables 6 and 9 had no upsell attempt. That's ~$11 left on the table.</div>
      </div>
      <div class="nav-bottom">
        <span class="active">◉ Shift</span>
        <span>◎ Skills</span>
        <span>◎ Earn</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- ===== ROW 2: SKILLS & GROWTH ===== -->
  <div class="row-label">Skills</div>

  <!-- DUOLINGO SKILLS -->
  <div class="phone">
    <div class="duo-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="duo-top-bar">
        <div class="duo-streak">🔥 4</div>
        <div class="duo-xp">⚡ 340 XP</div>
        <div class="duo-hearts">❤️ 5</div>
      </div>
      <div class="duo-section-title">Your Skill Tree</div>
      <div class="duo-skill-tree">
        <div class="duo-skill-row">
          <div class="duo-skill-node complete">👋</div>
          <div class="duo-skill-label">Greetings</div>
        </div>
        <div class="duo-skill-connector done"></div>
        <div class="duo-skill-row">
          <div class="duo-skill-node complete">🍷</div>
          <div class="duo-skill-label">Drink Upsell</div>
        </div>
        <div class="duo-skill-connector done"></div>
        <div class="duo-skill-row">
          <div class="duo-skill-node current">🍰</div>
          <div class="duo-skill-label">Dessert Upsell</div>
        </div>
        <div class="duo-skill-connector"></div>
        <div class="duo-skill-row">
          <div class="duo-skill-node locked">🥩</div>
          <div class="duo-skill-label">Premium Entrée</div>
        </div>
        <div class="duo-skill-connector"></div>
        <div class="duo-skill-row">
          <div class="duo-skill-node locked">🌟</div>
          <div class="duo-skill-label">VIP Service</div>
        </div>
      </div>
      <div class="duo-progress-card">
        <div class="header">
          <div class="title">🍰 Dessert Upsell</div>
          <div class="badge">Level 3</div>
        </div>
        <div style="font-size:12px;color:#AFAFAF;font-weight:600">2 of 5 practice shifts to Level 4</div>
        <div class="bar"><div class="fill" style="width:40%;background:linear-gradient(90deg,#FFD900,#FFC107)"></div></div>
      </div>
      <div class="nav-bottom">
        <span>◎ Today</span>
        <span class="active">◉ Skills</span>
        <span>◎ Badges</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- SPOTIFY SKILLS -->
  <div class="phone">
    <div class="spot-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="spot-section-head"><h3>Your Skills</h3><div class="see-all">See all</div></div>
      <div class="spot-skill-cards">
        <div class="spot-skill-card s1"><span class="emoji">👋</span><div class="name">Greetings</div><div class="level">Mastered</div></div>
        <div class="spot-skill-card s2"><span class="emoji">🍷</span><div class="name">Drink Upsell</div><div class="level">Level 5</div></div>
        <div class="spot-skill-card s3"><span class="emoji">🍰</span><div class="name">Dessert</div><div class="level">Level 3</div></div>
      </div>
      <div class="spot-section-head" style="margin-top:8px"><h3>Your Growth Mix</h3></div>
      <div class="spot-mix-card">
        <div class="cover">📊</div>
        <div class="info">
          <div class="title">This Week's Focus</div>
          <div class="sub">Based on your shift patterns and strengths</div>
          <div class="tags">
            <span class="tag-pill">Desserts</span>
            <span class="tag-pill">Wine Pairings</span>
            <span class="tag-pill">Timing</span>
          </div>
        </div>
      </div>
      <div class="spot-section-head"><h3>Skill Ranking</h3></div>
      <div class="spot-progress-row">
        <div class="spot-progress-item">
          <div class="rank-dot top">94</div>
          <div class="info"><div class="name">Greeting Score</div><div class="sub">Personal best — top 5% of servers</div></div>
          <div class="bar-wrap"><div class="bar"><div class="fill" style="width:94%;background:#1DB954"></div></div></div>
        </div>
        <div class="spot-progress-item">
          <div class="rank-dot top">78</div>
          <div class="info"><div class="name">Upsell Rate</div><div class="sub">Above average — up 12% from last month</div></div>
          <div class="bar-wrap"><div class="bar"><div class="fill" style="width:78%;background:#8B5CF6"></div></div></div>
        </div>
        <div class="spot-progress-item">
          <div class="rank-dot mid">61</div>
          <div class="info"><div class="name">Premium Pairing</div><div class="sub">Growing — try wine + entrée combos</div></div>
          <div class="bar-wrap"><div class="bar"><div class="fill" style="width:61%;background:#F59E0B"></div></div></div>
        </div>
        <div class="spot-progress-item">
          <div class="rank-dot mid">45</div>
          <div class="info"><div class="name">Table Turnover</div><div class="sub">Room to improve — 2.1 turns/hr</div></div>
          <div class="bar-wrap"><div class="bar"><div class="fill" style="width:45%;background:#666"></div></div></div>
        </div>
      </div>
      <div class="nav-bottom">
        <span>◎ Recap</span>
        <span class="active">◉ Grow</span>
        <span>◎ Awards</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- CASH APP SKILLS -->
  <div class="phone">
    <div class="cash-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="cash-metric-header"><h2>Greeting Score</h2></div>
      <div class="cash-big-metric">
        <div class="number" style="color:#fff">94<span style="font-size:32px;color:#444">%</span></div>
        <div class="unit">Personal Best</div>
        <div class="change up">↑ 8% vs. last Friday</div>
      </div>
      <div class="cash-sparkline">
        <div class="row">
          <div class="bar" style="height:45%"></div>
          <div class="bar" style="height:55%"></div>
          <div class="bar active" style="height:62%"></div>
          <div class="bar" style="height:50%"></div>
          <div class="bar active" style="height:70%"></div>
          <div class="bar active" style="height:78%"></div>
          <div class="bar active" style="height:85%"></div>
          <div class="bar current" style="height:94%"></div>
        </div>
        <div class="labels"><span>Mar 1</span><span>Mar 7</span><span>Mar 14</span><span>Today</span></div>
      </div>
      <div class="cash-divider" style="margin-top:16px"></div>
      <div class="cash-skill-list">
        <div class="cash-skill-item">
          <div class="indicator green">A</div>
          <div class="info"><div class="name">Greetings</div><div class="sub">94% — Personal best</div></div>
          <div class="score green">94</div>
        </div>
        <div class="cash-skill-item">
          <div class="indicator green">B+</div>
          <div class="info"><div class="name">Upsell Rate</div><div class="sub">3 of 8 tables — 38% conversion</div></div>
          <div class="score green">78</div>
        </div>
        <div class="cash-skill-item">
          <div class="indicator yellow">B-</div>
          <div class="info"><div class="name">Wine Pairing</div><div class="sub">1 upgrade — room to grow</div></div>
          <div class="score yellow">61</div>
        </div>
        <div class="cash-skill-item">
          <div class="indicator gray">C</div>
          <div class="info"><div class="name">Table Coverage</div><div class="sub">2 tables had no upsell attempt</div></div>
          <div class="score gray">45</div>
        </div>
      </div>
      <div class="nav-bottom">
        <span>◎ Shift</span>
        <span class="active">◉ Skills</span>
        <span>◎ Earn</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- ===== ROW 3: ACHIEVEMENTS & REWARDS ===== -->
  <div class="row-label">Achievements</div>

  <!-- DUOLINGO ACHIEVEMENTS -->
  <div class="phone">
    <div class="duo-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="duo-top-bar">
        <div class="duo-streak">🔥 4</div>
        <div class="duo-xp">⚡ 340 XP</div>
        <div class="duo-hearts">❤️ 5</div>
      </div>
      <div class="duo-chest">
        <div class="icon">🎁</div>
        <div class="text">
          <div class="title">Shift Chest Unlocked!</div>
          <div class="sub">You earned a reward chest for hitting 300+ XP tonight</div>
        </div>
      </div>
      <div class="duo-section-title">Badges Earned</div>
      <div class="duo-trophy-grid">
        <div class="duo-trophy earned">
          <span class="icon">🏆</span>
          <div class="name">Friday MVP</div>
          <div class="sub">Top server tonight</div>
        </div>
        <div class="duo-trophy earned">
          <span class="icon">🔥</span>
          <div class="name">4-Day Streak</div>
          <div class="sub">Keep it going!</div>
        </div>
        <div class="duo-trophy earned">
          <span class="icon">💎</span>
          <div class="name">94% Greeting</div>
          <div class="sub">Personal best</div>
        </div>
        <div class="duo-trophy earned">
          <span class="icon">🍰</span>
          <div class="name">Dessert Pro</div>
          <div class="sub">2 desserts upsold</div>
        </div>
        <div class="duo-trophy earned">
          <span class="icon">🍷</span>
          <div class="name">Sommelier</div>
          <div class="sub">Wine upgrade</div>
        </div>
        <div class="duo-trophy locked">
          <span class="icon">🌟</span>
          <div class="name">Perfect Shift</div>
          <div class="sub">100% greeting</div>
        </div>
        <div class="duo-trophy locked">
          <span class="icon">👑</span>
          <div class="name">Weekly King</div>
          <div class="sub">Top 7 days straight</div>
        </div>
        <div class="duo-trophy locked">
          <span class="icon">🎯</span>
          <div class="name">5x Upsell</div>
          <div class="sub">5 upsells in one shift</div>
        </div>
        <div class="duo-trophy locked">
          <span class="icon">💸</span>
          <div class="name">$100 Night</div>
          <div class="sub">$100+ tip boost</div>
        </div>
      </div>
      <div class="duo-lesson-card" style="border-color:#58CC02;background:#F0FFF0;margin-top:4px">
        <div class="icon">🎯</div>
        <div class="text">
          <div class="title">Next goal: 5 upsells in one shift</div>
          <div class="sub">You're 2 away — try tomorrow's lunch rush</div>
        </div>
        <div class="arrow" style="color:#58CC02">›</div>
      </div>
      <div class="nav-bottom">
        <span>◎ Today</span>
        <span>◎ Skills</span>
        <span class="active">◉ Badges</span>
        <span>◎ Profile</span>
      </div>
    </div>
  </div>

  <!-- SPOTIFY ACHIEVEMENTS -->
  <div class="phone">
    <div class="spot-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="spot-wrapped-card green">
        <div class="big-num">$47</div>
        <div class="label">Tip boost tonight — your 3rd best ever</div>
        <div class="sub">Top 18% of all servers at The Grove</div>
      </div>
      <div class="spot-section-head"><h3>Tonight's Awards</h3></div>
      <div class="spot-badge-row">
        <div class="spot-badge earned"><span class="icon">🏆</span><div class="name">Friday MVP</div></div>
        <div class="spot-badge earned"><span class="icon">🔥</span><div class="name">4-Day Streak</div></div>
        <div class="spot-badge earned"><span class="icon">💎</span><div class="name">Best Greeting</div></div>
        <div class="spot-badge locked"><span class="icon">👑</span><div class="name">Week King</div></div>
        <div class="spot-badge locked"><span class="icon">💸</span><div class="name">$100 Night</div></div>
      </div>
      <div class="spot-wrapped-card purple" style="margin-top:8px">
        <div class="big-num" style="font-size:48px">94%</div>
        <div class="label">Greeting score — personal best</div>
        <div class="sub">Previously 86% — set on March 12</div>
      </div>
      <div class="spot-highlight" style="margin-top:8px">
        <div class="icon green">📊</div>
        <div class="text">
          <div class="title">Your March so far</div>
          <div class="sub">18 shifts · $412 total tip boost · 7 badges earned</div>
        </div>
      </div>
      <div class="spot-play-bar" style="margin-top:4px">
        <div class="dot"></div>
        <div class="text">Next milestone: <strong>$500 monthly tip boost</strong> — $88 away</div>
      </div>
      <div class="nav-bottom">
        <span>◎ Recap</span>
        <span>◎ Grow</span>
        <span class="active">◉ Awards</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>

  <!-- CASH APP ACHIEVEMENTS -->
  <div class="phone">
    <div class="cash-screen">
      <div class="status-bar"><span>10:12 PM</span><span>WiFi &nbsp; 67%</span></div>
      <div class="cash-total-header">
        <div class="label">March Earnings</div>
        <div class="amount"><span class="green">$412</span></div>
        <div class="sub">18 shifts · $22.89 avg per shift</div>
      </div>
      <div class="cash-divider"></div>
      <div style="padding:16px 24px 8px"><div class="cash-breakdown-title">Tonight's Achievements</div></div>
      <div class="cash-achievement-list">
        <div class="cash-achievement">
          <div class="badge-icon earned">🏆</div>
          <div class="info"><div class="name">Friday MVP</div><div class="sub">Highest tip boost on tonight's shift</div></div>
          <div class="check">✓</div>
        </div>
        <div class="cash-achievement">
          <div class="badge-icon earned">🔥</div>
          <div class="info"><div class="name">4-Day Streak</div><div class="sub">Upsell on 4 consecutive shifts</div></div>
          <div class="check">✓</div>
        </div>
        <div class="cash-achievement">
          <div class="badge-icon earned">💎</div>
          <div class="info"><div class="name">Personal Best</div><div class="sub">94% greeting score — new record</div></div>
          <div class="check">✓</div>
        </div>
        <div class="cash-achievement">
          <div class="badge-icon locked">💸</div>
          <div class="info"><div class="name">$100 Night</div><div class="sub">$100+ tip boost in a single shift</div></div>
          <div class="locked-text">$53 away</div>
        </div>
        <div class="cash-achievement">
          <div class="badge-icon locked">👑</div>
          <div class="info"><div class="name">Monthly Champion</div><div class="sub">Highest total tip boost for the month</div></div>
          <div class="locked-text">$88 to goal</div>
        </div>
      </div>
      <div class="cash-cta">
        <div class="text">Cash out $47 tip boost</div>
        <div class="sub">Deposits to your linked account in 1–2 days</div>
      </div>
      <div class="nav-bottom">
        <span>◎ Shift</span>
        <span>◎ Skills</span>
        <span class="active">◉ Earn</span>
        <span>◎ You</span>
      </div>
    </div>
  </div>
</div>

<p class="footer">Concept mockups for design partner discussion — March 2026</p>

</body>
</html>`;

export default bespokeServerAppMockups2Html;
